import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '../../../shared/services/user.service';
import { Menu } from '../../../shared/components/accordion-menu/types/Menu';
import { Config } from '../../../shared/components/accordion-menu/types/Config';
import { AccordionMenuComponent } from '../../../shared/components/accordion-menu/accordion-menu.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCalculator, faListAlt, faBriefcase, faFileAlt, faUsers } from '@fortawesome/free-solid-svg-icons';
import { ADMIN_PROFILES } from '../../../shared/model/domain/usuarioAbm';


@Component({
    selector: 'app-sidebar',
    imports: [AccordionMenuComponent, FontAwesomeModule],
    templateUrl: './sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

  currentRoute: string = '';
  options: Config = { multi: false };
  menus: Menu[] = [
    {
      name: 'Seguro Nuevo',
      iconClass: faCalculator,
      active: false,
      url: '/home/seguronuevo',
      submenu: []
    },
    {
      name: 'Consultas',
      iconClass: faListAlt,
      active: false,
      url: '',
      submenu: [
        { name: 'Operaciones', url: '/home/operaciones' },
        { name: 'Renovaciones', url: '/home/renovaciones' },
        { name: 'Cartera', url: '/home/cartera' }
      ]
    },
    {
      name: 'Documentos Manuales',
      iconClass: faBriefcase,
      active: false,
      url: '',
      submenu: [
        { name: 'Consultar', url: '/home/documentos' },
        { name: 'Nuevo', url: '/home/documentos/nuevo' }
      ]
    }
  ];

  constructor(
    private router: Router,
    private userSvc: UserService
  ) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url
      }
    })

    this.userSvc.getUserProfile().subscribe({
      next: profiles => {
        if (profiles.clave != undefined){
          if (profiles?.clave == "Usuario Interno") {
            this.MostrarMenuReporteCotizacion();
          }
          if (ADMIN_PROFILES.includes(profiles?.clave)) {
            this.MostrarMenuAdministracion();
          }
        } else {
          this.userSvc.getUserProfiles().subscribe({
            next: profiles => {
              if (profiles != undefined && profiles.length > 0){
                if (profiles.some(p => p.clave == "Usuario Interno")) {
                  this.MostrarMenuReporteCotizacion();
                }
                const isInterno = profiles.some(p => p.clave == "Usuario Interno");
                if (isInterno && profiles.some(p => ADMIN_PROFILES.includes(p.clave))) {
                  this.MostrarMenuAdministracion();
                }
              }
            }
          })
        }
      }
    })
  }

  private MostrarMenuReporteCotizacion() {
    var menuInterno: Menu[] = [{
      name: 'Reporte Cotización',
      iconClass: faFileAlt,
      active: false,
      url: '/home/reportes',
      submenu: []
    }];
    this.menus = this.menus.concat(menuInterno);
  }

  private MostrarMenuAdministracion() {
    var menuAdmin: Menu[] = [{
      name: 'Administración',
      iconClass: faUsers,
      active: false,
      url: '',
      submenu: [
        { name: 'Usuarios', url: '/home/usuarios' }
      ]
    }];
    this.menus = this.menus.concat(menuAdmin);
  }

  ngOnInit() {

  }
}
